import {numberText} from "../public/js/utils/sanitize.js";
import {PlayingCard} from "./PlayingCard.jsx";
import {useTick} from "./useGame.js";

// A mini-game on the bar: a card-table mat dealt over the middle of the counter with
// every hand on it — or, for the ballot, who has voted and never for whom — and the
// countdown on a brass plate. It waits while a card is still in the air, so the card
// that started the game slides first, and it is gone once the game is settled: the
// payout is a card show of its own and takes the bar back.
export function MinigameTable({controller, waiting}) {
  const table = controller.minigameTable();
  useTick(Boolean(table));
  if (!table) return null;

  return (
    <div className={`minigame-table kind-${table.kind} phase-${table.phase}${waiting ? " waiting" : ""}`}>
      <div className="minigame-mat">
        <header className="minigame-mat-head">
          <h2>{table.title}</h2>
          <span className={table.urgent ? "minigame-plate urgent" : "minigame-plate"} role="timer">
            {numberText(table.seconds)}
          </span>
        </header>
        <p className="minigame-mat-note">{table.note}</p>
        <ul className="minigame-seats">
          {table.rows.map((row) => (
            <li
              key={row.id}
              className={`minigame-seat status-${row.status}${row.winner ? " winner" : ""}`}
              style={{"--seat-color": row.color}}
            >
              <span className="avatar"><span aria-hidden="true">{row.icon}</span></span>
              <span className="minigame-seat-name">{row.name}</span>
              {row.cards.length > 0 && (
                <span className="playing-cards">
                  {row.cards.map((card, index) => <PlayingCard key={`${card.code}-${index}`} card={card} />)}
                </span>
              )}
              <strong className="minigame-seat-status">{row.statusText}</strong>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
